import { useContext } from 'react';
import { AuthContext, type AuthContextValue } from './authContext';

/**
 * Access the auth context. Throws if used outside an <AuthProvider/> —
 * which is always a programming error we want to surface loudly in tests.
 */
export const useAuth = (): AuthContextValue => {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuth must be used within <AuthProvider/>');
  }
  return ctx;
};
